'use strict';

// External Dependencies
var get = require('lodash/get');

// Internal Dependencies
var leadInterest = require('../enums/leadInterest');

exports.updateActivityIndicator = function (_ref) {
  var recommendation = _ref.recommendation,
      activityIndicator = _ref.activityIndicator;

  var newComments = get(recommendation, 'activity.comments');
  var newInterest = get(recommendation, 'activity.interest');
  if (newComments) {
    activityIndicator.comments++;
  }
  if (newInterest) {
    switch (recommendation.isInterested) {
      case leadInterest[0]:
        {
          activityIndicator.sendProposal++;
          break;
        }
      case leadInterest[1]:
        {
          activityIndicator.notGoodFit++;
          break;
        }
      case leadInterest[2]:
        {
          activityIndicator.notSure++;
          break;
        }
    }
  }

  if (recommendation.isInterested && recommendation.isInterested === leadInterest[0]) {
    activityIndicator.totalSendProposals++;
  }

  handleCAWPActivity({ recommendation: recommendation, activityIndicator: activityIndicator });

  return activityIndicator;
};

exports.lastAvailability = function (recommendation) {
  var availabilityDeltas = get(recommendation, 'availabilityDeltas', []);
  if (availabilityDeltas.length) {
    return availabilityDeltas[availabilityDeltas.length - 1];
  }
};

function handleCAWPActivity(_ref2) {
  var recommendation = _ref2.recommendation,
      activityIndicator = _ref2.activityIndicator;

  var conversation = recommendation.conversation;
  if (!conversation) {
    return;
  }

  if (recommendation.createdThrough === 'Concierge') {
    activityIndicator.recoBR++;
  }

  if (recommendation.createdThrough === 'Booking Request') {
    activityIndicator.bookingRequests++;
  }

  if (conversation.requestState === 'PROPOSAL') {
    activityIndicator.unrespondedCAWPs++;
  }

  if (conversation.requestState === 'REQUEST') {
    activityIndicator.unrespondedBRs++;
  }

  if (conversation.requestState === 'INCOMPLETE') {
    activityIndicator.incompleteBRs++;
  }
}